import { render, staticRenderFns } from "./FavoriteOffersIndex.vue?vue&type=template&id=59b8c4f5&"
import script from "./FavoriteOffersIndex.vue?vue&type=script&lang=js&"
export * from "./FavoriteOffersIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports